var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsxs as _jsxs, jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useFocusRing } from '@react-aria/focus';
import { mergeProps } from '@react-aria/utils';
import { cloneElement } from 'react';
import { logError, setTitleCase } from '../helpers';
import { MESSAGES } from './debug-messages';
import ButtonLoader from './loader';
import { buttonStyle, getThemedStyle, innerContentStyle } from './styles';
function ButtonInternal(_a, ref) {
    var ariaLabel = _a["aria-label"], as = _a.as, children = _a.children, _b = _a.disableTitleCase, disableTitleCase = _b === void 0 ? false : _b, _c = _a.fullWidth, fullWidth = _c === void 0 ? false : _c, icon = _a.icon, iconLeft = _a.iconLeft, iconRight = _a.iconRight, _d = _a.inverted, inverted = _d === void 0 ? false : _d, _e = _a.isLoading, isLoading = _e === void 0 ? false : _e, _f = _a.size, size = _f === void 0 ? 'medium' : _f, type = _a.type, _g = _a.variant, variant = _g === void 0 ? 'secondary' : _g, restProps = __rest(_a, ['aria-label', "as", "children", "disableTitleCase", "fullWidth", "icon", "iconLeft", "iconRight", "inverted", "isLoading", "size", "type", "variant"]);
    var Element = as !== null && as !== void 0 ? as : 'button';
    var _h = useFocusRing(), focusProps = _h.focusProps, isFocusVisible = _h.isFocusVisible;
    var typedRestProps = restProps;
    var themedStyle = getThemedStyle({ variant: variant });
    var buttonAriaLabel;
    if (typeof ariaLabel === 'string' || ariaLabel === undefined) {
        buttonAriaLabel = isLoading ? ariaLabel === null || ariaLabel === void 0 ? void 0 : ariaLabel.concat(' ', 'Loading') : ariaLabel;
    }
    else if (typeof ariaLabel === 'function') {
        buttonAriaLabel = ariaLabel(isLoading);
    }
    // Log console.error when an empty string is passed as incorrect syntax
    if (typeof children === 'string' && children.length === 0) {
        logError(MESSAGES.EMPTY_CHILDREN);
    }
    function renderIcon(originalIcon, key) {
        // Check if the Icon has a provided custom size prop already
        return originalIcon.props.size != null
            ? originalIcon
            : cloneElement(originalIcon, {
                key: key,
                size: size,
                style: { flexShrink: 0 },
            });
    }
    return (_jsxs(Element, __assign({}, mergeProps(focusProps, typedRestProps), { "aria-label": buttonAriaLabel, css: buttonStyle({
            fullWidth: fullWidth,
            inverted: inverted,
            isFocusVisible: isFocusVisible,
            isIconOnly: !(icon == null),
            isLoading: isLoading,
            size: size,
            themedStyle: themedStyle,
        }), ref: ref, type: type == null && Element === 'button' ? 'button' : type }, (isLoading && {
        disabled: true,
    }), { children: [icon != null ? (renderIcon(icon, 'button-icon-only')) : (_jsxs("span", __assign({ css: innerContentStyle({ size: size }) }, { children: [iconLeft != null && renderIcon(iconLeft, 'button-left-icon'), typeof children === 'string' && !disableTitleCase
                        ? setTitleCase(children)
                        : children, iconRight != null && renderIcon(iconRight, 'button-right-icon')] }))), isLoading && (_jsx(ButtonLoader, __assign({}, {
                isIconOnly: !(icon == null),
                size: size,
                themedStyle: themedStyle,
            }), "button-loader"))] })));
}
export default ButtonInternal;
